import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Button from './Button';
import React from 'react';

export default React.forwardRef(function FocusableButton(props, ref) {
  return (
    <Button
      {...{
        type: 'button',
        tabIndex: 0,
        focusable: true,
        ref,
      }}
      {...ex('FocusableButton', props)}
    >
    </Button>
  );
});
